import React, { useEffect, useRef, useState } from "react";
import {
  postGetAllPlanOptions,
  postUpSertPlanOption,
} from "../../../../core/api/Api";
import DataTable from "../../../_components/datatable/DataTable";
import { useNavigate, useParams } from "react-router-dom";

const PlanOptions = () => {
  let { plan_id } = useParams();
  const mounted = useRef(true);
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    { field: "name", headerName: "Name" },
    { field: "description", headerName: "Description" },
  ];

  const getData = (data) => {
    setLoading(true);
    data.plan_id = plan_id;
    postGetAllPlanOptions(data)
      .then((res) => {
        setLoading(false);
        if (mounted.current && res?.data?.success) {
          const data = res.data.success;
          setData(data);
        }
      })
      .catch((e) => {
        if (mounted.current) setLoading(false);
      });
  };

  const onDeleteDataTableRows = (data) => {
    setLoading(true);
    data.plan_id = plan_id;
    postUpSertPlanOption(data)
      .then((res) => {
        setLoading(false);
        if (mounted.current && res?.data?.success) {
          const data = res.data.success;
          setData(data);
        }
      })
      .catch((e) => {
        if (mounted.current) setLoading(false);
      });
  };

  const onRowClick = (e) => {
    navigate("/plan-option-details/" + e.id + "/plan/" + plan_id);
  };

  const onCreateButtonClick = () => {
    navigate("/plan-option-details/create/plan/" + plan_id);
  };

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <DataTable
      columns={columns}
      data={data}
      loading={loading}
      onPageChangeProp={getData}
      onRowClick={onRowClick}
      onCreateButtonClick={onCreateButtonClick}
      onDeleteDataTableRows={onDeleteDataTableRows}
    />
  );
};

export default PlanOptions;
